import { render, staticRenderFns } from "./SetQuickBar.vue?vue&type=template&id=7a0c6c8a"
import script from "./SetQuickBar.vue?vue&type=script&lang=js"
export * from "./SetQuickBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports